<template>
  <b-modal id="device" title="Dispositivo" @ok="save" ok-title="Salva" @cancel="initValues()" cancel-title="Annulla" hide-header-close no-close-on-backdrop>
    <b-form-group class="col-md-12">
      <b-card-text>
        <b-form-row>
          <b-form-group label="Numero" class="col-md-4">
            <b-form-input
              id="name"
              v-model="ordinalNumber"
              name="Numero"
              disabled/>
          </b-form-group>
          <b-form-group label="Negozio" class="col-md-8">
            <b-form-input
              id="code"
              name="Codice"
              placeholder="MG - MAGAZZINO DAO"
              disabled/>
          </b-form-group>
          <b-form-group label="Modello" class="col-md-8">
            <b-form-input
              id="code"
              name="Modello"
              placeholder="Samsung Galaxy Tab Active 3"
              disabled/>
          </b-form-group>
          <b-form-group label="Pin" class="col-md-4">
            <b-form-input
              id="pin"
              v-model="device.pin"
              name="PIN"
              v-validate="{ min: 4, max: 6, required: true}"
              :state="stateValidation('PIN')"
              aria-describedby="input-pin-feedback" />
            <b-form-invalid-feedback id="input-pin-feedback">
              {{ veeErrors.first('PIN')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Numero Seriale" class="col-md-12">
            <b-form-input
              class="text-uppercase"
              id="serialNumber"
              v-model="device.serialNumber"
              name="Numero Seriale"
              v-validate="{ min: 11, max: 11, required: true}"
              :state="stateValidation('Numero Seriale')"
              aria-describedby="input-serial-number-feedback"/>
            <b-form-invalid-feedback id="input-serial-number-feedback">
              {{ veeErrors.first('Numero Seriale')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="IMEI" class="col-md-12">
            <b-form-input
              id="imei"
              class="text-uppercase"
              v-model="device.imei"
              name="IMEI"
              v-validate="{ min: 15, max: 15, required: true, numeric: true }"
              :state="stateValidation('IMEI')"
              aria-describedby="input-imei-feedback"/>
            <b-form-invalid-feedback id="input-imei-feedback">
              {{ veeErrors.first('IMEI')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Indirizzo MAC" class="col-md-12">
            <b-form-input
              id="MAC"
              v-model="device.macAddress"
              name="MAC"
              @update="addDoubleDots"
              v-validate="{ required: true, regex: /^([0-9A-F]{2}:){5}([0-9A-F]{2})$/ }"
              :state="stateValidation('MAC')"
              aria-describedby="input-mac-feedback"/>
            <b-form-invalid-feedback id="input-mac-feedback">
              {{ veeErrors.first('MAC')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <b-link href="https://docs.google.com/document/d/1uEbSmDPyS7uSrhyPX0TejShzxcl7-l5mesXlx9tuVFs">Preparazione tablet</b-link>
          </b-form-group>
        </b-form-row>
      </b-card-text>
    </b-form-group>
  </b-modal>
</template>

<script>

import Tablets from "@/api/TabletsApi";

export default {
  name: "Device",
  components: {},
  props: ['ordinalNumber', 'eventName'],
  inject: ['parentValidator'],
  data: () => ({
    device: {},
  }),
  created() {
    this.$validator = this.parentValidator
  },
  methods: {
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    },
    save(modalEvent) {
      modalEvent.preventDefault()

      this.$validator.validateAll().then(result => {
        if (result) {
          this.device = {
            ...this.device,
            ordinalNumber: this.ordinalNumber,
            imei: this.device.imei.toUpperCase(),
            serialNumber: this.device.serialNumber.toUpperCase(),
            macAddress: this.device.macAddress.toUpperCase(),
            updated: this.device.version === Tablets.getLastVersion,
          }
          console.log(this.device)
          this.$emit(this.eventName, this.device)
          this.initValues()
        }
      })
    },
    initValues() { this.device = {} },
    addDoubleDots() {
      if ((this.device.macAddress.length+1)%3 === 0 && (this.device.macAddress.length)<17 ) {
        this.device.macAddress = this.device.macAddress.concat(":")
      }
      this.device.macAddress = this.device.macAddress.toUpperCase()
    }
  }
}
</script>

<style scoped>
</style>
